<template>
    <div>
        <!-- <v-icon class="pb-1">{{ "mdi-chevron-left" }}</v-icon> -->
        <Button @click="action" rounded outlined color="primary">
            {{ $t("action.back") }}
        </Button>
    </div>
</template>

<script>
    import RouterLinkMixin from "@/components/routing/RouterLinkMixin"

    export default {
        mixins: [RouterLinkMixin],

        methods: {
            defaultTo() {
                return -1
            },
        },
    }
</script>

<style lang="scss" scoped></style>
